import React from 'react';
import { createPortal } from 'react-dom';

export default function MobileBottomSheet({ isOpen, onClose, children, sheetClassName = '', sheetStyle = undefined, contentClassName = '' }) {
  if (!isOpen) return null;

  const sheet = (
    <div className="fixed inset-0 z-[20000] flex flex-col modal-text pointer-events-none">
      {/* Zone cliquable (30% haut) pour fermer */}
      <button
        type="button"
        aria-label="Fermer"
        className="flex-1 w-full bg-transparent pointer-events-auto"
        onClick={onClose}
      />

      {/* Feuille en bas */}
      <div
        className={`w-full min-h-[50vh] max-h-[70vh] bg-[#1c1c1f] text-white rounded-t-2xl border-t border-white/10 shadow-2xl animate-slide-up overflow-hidden pointer-events-auto ${sheetClassName}`}
        style={sheetStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-center pt-2">
          <div className="h-1 w-10 rounded-full bg-white/20" />
        </div>
        <div className={`max-h-[calc(70vh-16px)] overflow-y-auto px-4 pb-[env(safe-area-inset-bottom,0px)] ${contentClassName}`}>
          {children}
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return null;
  return createPortal(sheet, document.body);
}
